import { useStrictInstance } from '@funtech-int/rival-react';

import { profileManagerRef } from '../lib/profileManager';

export function useProfileManager() {
    return useStrictInstance(profileManagerRef);
}
